function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

export { _iterableToArray as default };
//# sourceMappingURL=iterableToArray.js.map
